module.exports = __webpack_public_path__ + "img/periodicoa.2edb7fc2.jpg";